import React, { useContext, useEffect, useState } from "react";
import successIcon from "../../images/successGreenIcon.png";
import errorIcon from "../../images/errorRedIcon.png";
import LoadingIcon from "../../images/Loading_icon.gif";
import { UrlContext } from "../../contexts/UrlContext";
import { AnimatePresence, motion } from "framer-motion";

export default function Skills({ expert_id, hideNumber, setExistSkill, setHasSkill }) {
  const [skills, setSkills] = useState([]);
  const [showAddSkill, setShowAddSkill] = useState(false);
  const [expertSkills, setExpertSkills] = useState([]);
  const [exSkillsFetched, setExSkillsFetched] = useState(false);
  const [skillCount, setSkillCount] = useState(0);
  const [returnSuccess, setReturnSuccess] = useState(false);
  const [returnError, setReturnError] = useState(false);
  const [loading, setLoading] = useState(false);
  const [showMore, setShowMore] = useState(false);
  const { API_URL } = useContext(UrlContext);
  const [newSkill, setNewSkill] = useState("");
  const [showDropdown, setShowDropdown] = useState(false);
  const [highlightedIndex, setHighlightedIndex] = useState(-1);

  const filteredSkills = skills.filter(skill =>
    skill.label.toLowerCase().includes(newSkill.toLowerCase())
  );
  
  useEffect(() => {
    const tokenObj = localStorage.getItem("eph-token");
    const token = JSON.parse(tokenObj).value || localStorage.getItem("AccessToken");
    fetch(`${API_URL}get-all-eph-skills`, {
      method: "GET",
      headers: {
        "Authorization": `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    })
      .then((res) => res.json())
      .then((data) => {
        const newSkills = data.skillList.map((skill) => ({
          label: skill,
          value: skill,
        }));
        setSkills(newSkills);
        if (newSkills.length > 0) {
          setHasSkill(true);}
        })
      .catch(console.error);
  }, []);

  function fetchExpertSkills() {
    const tokenObj = localStorage.getItem("eph-token");
    const token = JSON.parse(tokenObj).value || localStorage.getItem("AccessToken");
    fetch(`${API_URL}expert-profile-skills/${expert_id}`, {
      method: "GET",
      headers: {
        "Authorization": `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    })
      .then((res) => res.json())
      .then((data) => {
        setExpertSkills(data.expertSkill);
        setExSkillsFetched(true);
      })
      .catch(console.error);
  }

  useEffect(() => {
    fetchExpertSkills();
  }, [expert_id, skillCount]);

  const saveSkillsHandler = (values) => {
    const tokenObj = localStorage.getItem("eph-token");
    const token = JSON.parse(tokenObj).value || localStorage.getItem("AccessToken");
    setReturnError(false);
    setLoading(true);
    fetch(`${API_URL}update-expert-profile-skills/${expert_id}`, {
      method: "POST",
      headers: {
        "Authorization": `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ skills: values }),
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.status === "success") {
          setTimeout(() => {
            setLoading(false);
            setReturnSuccess(true);
          }, 500);
          setTimeout(() => setReturnSuccess(false), 2000);
          setSkillCount((prev) => prev + 1);
        } else {
          setLoading(false);
          setReturnError(true);
          setTimeout(() => setReturnError(false), 1500);
        }
      })
      .catch((err) => {
        setLoading(false);
        setReturnError(true);
        setTimeout(() => setReturnError(false), 1500);
        console.error(err);
      });
  };

  const removeExpertSkillHandler = (expertID, skillName) => {
    const tokenObj = localStorage.getItem("eph-token");
    const token = JSON.parse(tokenObj)?.value || localStorage.getItem("AccessToken");
    setReturnError(false);
    setLoading(true);

    fetch(`${API_URL}remove-expert-profile-skill`, {
      method: "POST",
      headers: {
        "Authorization": `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ expertID, skillName }),
    })
      .then((res) => res.json())
      .then((data) => {
        setLoading(false);
        if (data.status === "success") {
          fetchExpertSkills();
          setReturnSuccess(true);
          setTimeout(() => setReturnSuccess(false), 1500);
        } else {
          setReturnError(true);
          setTimeout(() => setReturnError(false), 1500);
        }
      })
      .catch((err) => {
        setLoading(false);
        setReturnError(true);
        setTimeout(() => setReturnError(false), 1500);
        console.error(err);
      });
  };

  return (
    <div
      className={`bg-white rounded-xl p-6 relative transition-all duration-300 ${
        showAddSkill ? "glow-burst glow-hold" : "shadow"
      }`}
    >
      <div className="flex justify-between items-center mb-2">
        <h3 className="text-lg font-semibold mb-2">{!showAddSkill ? 'Skills' : 'Add Skills'}</h3>
        {!showAddSkill ? (
          <button
            className="absolute top-5 right-6 text-gray-500 hover:text-black hover:bg-gray-200 py-1 px-2 rounded-full transition focus:outline-none"
            onClick={() => setShowAddSkill(true)}
            title="Edit Skills"
          >
            <i className="fa-solid fa-pencil" />
          </button>
        ) : (
          <button
            className="absolute top-5 right-6 text-gray-500 hover:text-black hover:bg-gray-200 py-1 px-2.5 rounded-full transition focus:outline-none"
            onClick={() => setShowAddSkill(false)}
            title="Cancel Edit"
          >
            <i className="fa-solid fa-xmark" />
          </button>
        )}
      </div>

      <AnimatePresence mode="wait">
        {!showAddSkill ? (
          <motion.div
            key="skills-view"
            initial={{ opacity: 0, height: 0 }}
            animate={{ opacity: 1, height: "auto" }}
            exit={{ opacity: 0, height: 0 }}
            transition={{ duration: 0.3 }}
            className="overflow-hidden"
          >
            <div className="skill-div relative">
              {exSkillsFetched &&
                (expertSkills.length === 0 ? (
                  <span className="text-gray-500">No skills added yet</span>
                ) : (
                  <>
                    <AnimatePresence mode="wait">
                      <motion.div
                        key={showMore ? "expanded" : "collapsed"}
                        initial={{ opacity: 0, height: 0 }}
                        animate={{ opacity: 1, height: "auto" }}
                        exit={{ opacity: 0, height: 0 }}
                        transition={{ duration: 0.3 }}
                        className="overflow-hidden"
                      >
                        {(showMore ? expertSkills : expertSkills.slice(0, 8)).map((skill, index) => (
                          <span
                            key={index}
                            className="chip skill-span bg-[#365561] text-white"
                            style={{ backgroundColor: "#365561"}}
                          >
                            {`${skill.skillName}${skill.count > 1 ? ` (${skill.count})` : ""}`}
                            <i
                              className="fa-solid fa-xmark cursor-pointer text-xs ml-2"
                              onClick={() =>
                                removeExpertSkillHandler(skill.expertID, skill.skillName)
                              }
                              title="Remove Skill"
                            />
                          </span>
                        ))}
                      </motion.div>
                    </AnimatePresence>
                    {expertSkills.length > 8 && (
                      <button
                        onClick={() => setShowMore(!showMore)}
                        className="text-blue-600 text-xs focus:outline-none hover:underline"
                      >
                        {showMore ? "Show Less" : "Show More"}
                      </button>
                    )}
                  </>
                ))}
            </div>
          </motion.div>
        ) : (
          <motion.div
            key="skills-edit"
            initial={{ opacity: 0, height: 0 }}
            animate={{ opacity: 1, height: "auto" }}
            exit={{ opacity: 0, height: 0 }}
            transition={{ duration: 0.3 }}
            className="overflow-hidden"
          >
            <div className="skill-div relative mb-3">
              {expertSkills.map(
                (skill, index) => (
                  <span
                    key={index}
                    className="chip skill-span bg-[#365561] text-white"
                    style={{ backgroundColor: "#365561" }}
                  >
                    {`${skill.skillName}${skill.count > 1 ? ` (${skill.count})` : ""}`}
                    <i
                      className="fa-solid fa-xmark cursor-pointer text-xs"
                      onClick={() =>
                        removeExpertSkillHandler(
                          skill.expertID,
                          skill.skillName
                        )
                      }
                      title="Remove Skill"
                    />
                  </span>
                )
              )}
            </div>
            <div className="w-full">
              <input
                type="text"
                placeholder="Type a skill"
                value={newSkill}
                onChange={(e) => setNewSkill(e.target.value)}
                onFocus={() => setShowDropdown(true)}
                onBlur={() => setTimeout(() => setShowDropdown(false), 150)} // small delay to allow clicks
                className="w-full border-b border-gray-300 hover:border-[#365561] focus:border-[#365561] focus:outline-none text-sm pb-1 bg-white"
              />

              {/* Animated dropdown */}
              <AnimatePresence>
                {showDropdown && newSkill.length > 0 && filteredSkills.length > 0 && (
                  <motion.ul
                    key="dropdown"
                    initial={{ opacity: 0, y: -5 }}
                    animate={{ opacity: 1, y: 0 }}
                    exit={{ opacity: 0, y: -5 }}
                    transition={{ duration: 0.2 }}
                    className="autocomplete-scroll absolute z-10 w-[90%] bg-white border border-gray-200 rounded-md shadow-md mt-1 max-h-48 overflow-x-hidden"
                  >
                    {filteredSkills.map((skill, index) => (
                      <motion.li
                        key={skill.value}
                        className={`px-3 py-1 text-sm cursor-pointer select-none list-none ${
                          index === highlightedIndex
                            ? "bg-gray-100"
                            : "hover:bg-gray-100"
                        }`}
                        onMouseDown={() => {
                          setNewSkill(skill.label);
                          setShowDropdown(false);
                        }}
                        whileHover={{ scale: 1.02 }}
                      >
                        {skill.label}
                      </motion.li>
                    ))}
                  </motion.ul>
                )}
              </AnimatePresence>
            </div>
            <button
              className={`text-blue-600 text-xs hover:underline ${
                newSkill ? "animate-pulse text-blue-700 font-semibold" : ""
              }`}
              onClick={() => {
                if (!newSkill) return;
                saveSkillsHandler([{ label: newSkill, value: newSkill }]);
                setNewSkill("");
              }}
            >
              + Add
            </button>
          </motion.div>
        )}
      </AnimatePresence>

      {loading && (
        <img
          className="absolute bottom-3 right-4 h-5"
          src={LoadingIcon}
          alt="loading"
          title="Loading..."
        />
      )}
      {returnSuccess && (
        <img
          className="absolute bottom-3 right-4 h-5"
          src={successIcon}
          alt="success"
          title="Success"
        />
      )}
      {returnError && (
        <img
          className="absolute bottom-3 right-4 h-5"
          src={errorIcon}
          alt="error"
          title="Error"
        />
      )}

      <style>{`
        @keyframes glowBurst {
          0% { box-shadow: 0 0 0px 0px rgba(54, 85, 97, 0); }
          30% { box-shadow: 0 0 20px 6px rgba(54, 85, 97, 0.6); }
          100% { box-shadow: 0 0 15px 3px rgba(54, 85, 97, 0.6); }
        }
        .glow-burst {
          animation: glowBurst 0.8s ease-out forwards;
          border-radius: 0.75rem;
        }
        .glow-hold {
          box-shadow: 0 0 20px 6px rgba(54, 85, 97, 0.6);
          border-radius: 0.75rem;
        }

        .skill-div {
          display: flex;
          flex-wrap: wrap;
        }
        .skill-div b {
          border-radius: 11px;
          display: inline-flex;
          line-height: 19px;
          padding: 4px 0;
        }
        .skill-span i {
          margin-left: 8px;
          transition: color 0.2s ease, transform 0.2s ease;
        }
        .skill-span i:hover {
          color: #ef4444;
          transform: scale(1.15);
        }
      `}</style>
    </div>
  );
}